module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'normal-state': !_vm.showBar
    },
    attrs: {
      "id": "app"
    }
  }, [(_vm.showBar) ? _c('div', {
    staticClass: "top-bar"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.appInfo.app_logo,
      "width": "36",
      "height": "36",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.appInfo.app_name))]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v(_vm._s(_vm.appInfo.app_des))])]), _vm._v(" "), _c('span', {
    staticClass: "btn-close",
    on: {
      "click": function($event) {
        _vm.showBar = false
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.themecolor),
      expression: "themecolor"
    }],
    staticClass: "btn-openapp magx-btn theme-bg-color",
    on: {
      "click": _vm.jumpToAppPage
    }
  }, [_vm._v("立即打开")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "app-jump-overlay overlay"
  }, [_c('div', {
    staticClass: "app-jump-dialog dialog"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.appInfo.app_logo),
      expression: "appInfo.app_logo"
    }],
    staticClass: "app-logo",
    attrs: {
      "width": "78",
      "height": "78"
    }
  }), _vm._v(" "), (_vm.isInWeixin) ? _c('p', {
    staticClass: "des"
  }, [_vm._v("QQ／微信内限制无法进行此操作，请打开客户端后重试")]) : _vm._e(), _vm._v(" "), (!_vm.isInWeixin) ? _c('a', {
    staticClass: "button button-installed theme-bg-color"
  }, [_vm._v("已安装 > 打开应用查看本页")]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "button theme-bg-color",
    attrs: {
      "href": _vm.appInfo.app_download
    }
  }, [_vm._v("未安装 > 前去下载客户端")])])]), _vm._v(" "), _c('div', {
    staticClass: "fixed-btm-icons"
  }, [_c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFixedIndex),
      expression: "showFixedIndex"
    }],
    staticClass: "item",
    attrs: {
      "to": {
        path: '/'
      },
      "tag": "div"
    }
  }, [_c('span', {
    staticClass: "icon icon-gohome"
  }), _vm._v(" "), _c('span', {
    staticClass: "name"
  }, [_vm._v("首页")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPostForum),
      expression: "showPostForum"
    }],
    staticClass: "item",
    on: {
      "click": _vm.goPostForum
    }
  }, [_c('span', {
    staticClass: "icon icon-post-forum"
  }), _vm._v(" "), _c('span', {
    staticClass: "name"
  }, [_vm._v("发帖")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPostWshare),
      expression: "showPostWshare"
    }],
    staticClass: "item",
    on: {
      "click": _vm.goPostWshare
    }
  }, [_c('span', {
    staticClass: "icon icon-post-topic"
  }), _vm._v(" "), _c('span', {
    staticClass: "name"
  }, [_vm._v("拍摄")])])], 1), _vm._v(" "), _c('keep-alive', [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e48ea8f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 281
// module chunks = 40